import React from "react";

const formatTitle = (key) =>
  key
    .replace(/_/g, " ")
    .replace(/\b\w/g, (l) => l.toUpperCase());

const getProgressColor = (percentage) => {
  if (percentage >= 90) return "#dc3545";
  if (percentage >= 70) return "#f59e0b";
  return "#22c55e";
};

function UsageCard({
  title,
  data,
}) {
  const progressColor = getProgressColor(data.usage_percentage);

  return (
    <div
      className="rounded-3 p-4 h-100"
      style={{
        border: "1px solid rgba(85,91,103,.15)",
        background: "#fff",
      }}
    >
      <div className="d-flex justify-content-between align-items-center">

        <div>

          <div className="fs-4 fw-semibold">
            {formatTitle(title)}
          </div>

          <div className="text-muted mt-1">
            {data.total_consumed} of {data.total_allowed} used
          </div>

        </div>

        <div
          className="fw-semibold"
          style={{
            color: progressColor,
          }}
        >
          {data.usage_percentage}%
        </div>

      </div>

      <div
        className="progress mt-4"
        style={{
          height: 10,
          background: "#ececec",
        }}
      >
        <div
          className="progress-bar"
          style={{
            width: `${data.usage_percentage}%`,
            background: progressColor,
          }}
        />
      </div>

      <div className="row mt-4">

        <div className="col">

          <div className="text-muted fs-6">
            Consumed
          </div>

          <div className="fw-semibold">
            {data.total_consumed}
          </div>

        </div>

        <div className="col">

          <div className="text-muted fs-6">
            Remaining
          </div>

          <div className="fw-semibold">
            {data.remaining_quantity}
          </div>

        </div>

        <div className="col">

          <div className="text-muted fs-6">
            Limit
          </div>

          <div className="fw-semibold">
            {data.total_allowed}
          </div>

        </div>

      </div>

      {data.usage_percentage >= 90 && (
        <div
          className="mt-4 rounded-2 p-2"
          style={{
            background: "#FFF4F4",
            color: "#dc3545",
            fontSize: 13,
            fontWeight: 500,
          }}
        >
          ⚠ You're approaching your plan limit.
        </div>
      )}

    </div>
  );
}

export default UsageCard